module.exports = __webpack_public_path__ + "static/img/icon_refresh.34621f74.svg";